import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "./api";
import logo from "./assets/SONRISA.png";
import "./App.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await login(email, password);

      if (!res.ok) throw new Error(res.error || "Error al iniciar sesión");

      // ✅ Caso 1: primera vez → redirigir a "establecer contraseña"
      if (res.require_password_setup) {
        navigate(`/set-password?first=1&user=${res.user_id}`);
        return;
      }

      // ✅ Caso 2: contraseña expirada → redirigir al cambio obligatorio
      if (res.require_password_reset) {
        navigate(`/set-password?expired=1&email=${email}`);
        return;
      }

      // ✅ Caso 3: login normal → dashboard por rol
      const { role } = res.user;
      if (role === "admin") navigate("/admin", { replace: true });
      else if (role === "psicologa") navigate("/psicologia", { replace: true });
      else if (role === "logopeda") navigate("/logopedia", { replace: true });
      else if (role === "nutricionista")
        navigate("/nutricion", { replace: true });
      else navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <form className="login" onSubmit={handleSubmit}>
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="title">Iniciar Sesión</h1>

          {error && (
            <div className="error" role="alert">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              placeholder="usuario@ejemplo.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              placeholder="Ingresa tu contraseña"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="btn" type="submit" disabled={loading}>
            {loading ? "Entrando…" : "Enviar"}
          </button>

          <p className="password-link">
            ¿Olvidaste tu contraseña?{" "}
            <span className="link" onClick={() => navigate("/forgot-password")}>
              Recuperar contraseña
            </span>
          </p>
        </form>
      </header>
    </div>
  );
}
